export default theme => ({
	marginTop16: {
		marginTop: 16
	}
});
